exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contract-root>h1[data-v-7969f078]{text-align:center;font-size:1.5vw}.contract-root>p[data-v-7969f078]{line-height:2}.contract-root .indent[data-v-7969f078]{text-indent:2em}.contract-root .line-break[data-v-7969f078]{word-break:break-all}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"minimize":true,"importLoaders":1,"alias":{"/assets":"/opt/nodeapps/svndata/jzq-web/assets","/static":"/opt/nodeapps/svndata/jzq-web/static"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7969f078","scoped":true,"hasInlineConfig":true}!./node_modules/less-loader/dist/cjs.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./pages/initiation/invalidation/components/contract.vue
// module id = 707x
// module chunks = 100 226